import { Component, OnInit, EventEmitter, Input, Output, ViewChildren, QueryList, Inject, LOCALE_ID } from '@angular/core';
import { E5coreUiWorkDiariseBaseComponent } from './component/e5core-ui-work-diarise-base.component';
import { DiariseOptionModel } from '../../models/diarise-option.model';
import { DiariseOptionClickEvent } from '../../events/diarise-option-click-event';
import { DiariseUnit } from '../../enums/diarise-unit';
import { E5coreUiDatepickerComponent } from '../e5core-ui-datepicker/e5core-ui-datepicker.component';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';
import { WorkMenuItemFoundationService, WorkItemFoundationService } from 'e5core-angular-services';
import { formatDate, DatePipe } from '@angular/common';
import { DiariseReasonModel } from '../../models/diarise-reason.model';
import { DiariseMenuDataModel, AdditionalProperties } from '../../models/diarise-menu-data-model';
import { DiariseWorkEvent } from '../../events/diarise-work-event';

@Component({
    selector: 'e5core-ui-work-diarise',
    template: `<e5core-ui-work-diarise-material
               [periodOptions]='periodOptions'
               [reasons]='reasons'
               [displayedDate] ='displayedDate'
               [displayedTime] = 'displayedTime'
               [diariseReasonPropertyId] ='diariseReasonPropertyId'
               [diariseReasonPlaceHolder] ='diariseReasonPlaceHolder'
               [diariseReasonTextValue]='diariseReasonTextValue'
               [showDiariseButton]='showDiariseButton'
               [showDiariseTime]='showDiariseTime'
               (diariseWork)='onDiariseButtonClick($event)'
               (reasonTextChange)='onDiariseReasonTextChange($event)'
               (reasonChange)='onDiariseReasonChange($event)'
               (dateChange)='onDiariseDateChange($event)'
               (timeChange)="onTimeChange($event)"
               (periodChange)="onDiarisePeriodOptionClick($event)"
               [showDiariseReasonDropdown]='showDiariseReasonDropdown'
              >
             </e5core-ui-work-diarise-material>`
})
export class E5coreUiWorkDiariseComponent implements OnInit {
    @Input() workItem$: BehaviorSubject<WorkItemModel>;
    @Input() diariseReasons$: BehaviorSubject<DiariseReasonModel> ;
    @Output() dateChange = new EventEmitter<any>();
    @Output() reasonTextChange = new EventEmitter<any>();
    @Output() reasonChange = new EventEmitter<any>();
    @Output() diariseWork = new EventEmitter<DiariseWorkEvent>();
    @Output() timeChange = new EventEmitter<any>();

    @Input() periodOptions: DiariseOptionModel[];
    @Input() reasons: DiariseReasonModel[];
    @Input() diariseReasonPropertyId: string;
    @Input() displayedDate: Date;
    @Input() displayedTime: string;
    @Input() diariseReasonPlaceHolder: string;
    @Input() diariseReasonTextValue: string ;
    @Input() diariseReasonOption = '';
    @Input() showDiariseTime = true;
    @Input() showDiariseButton = true;
    @Input() showDiariseReasonDropdown = true;

    workItemModel: WorkItemModel;
    workId: string;
    diarisePeriodOption: DiariseOptionModel;
    diariseWorkEvent: DiariseWorkEvent;
    private _diariseDate: Date;
    public get diariseDate(): Date {
        return this._diariseDate;
    }
    public set diariseDate(value: Date) {
        this._diariseDate = value;
    }

    @ViewChildren('datepicker')
    public datePickerComponents: QueryList<E5coreUiDatepickerComponent>;
    constructor(
        private workItemFoundationService: WorkItemFoundationService,
        private workMenuItemService: WorkMenuItemFoundationService,
        @Inject(LOCALE_ID) private locale: string,
        private datePipe: DatePipe) {
    }

    ngOnInit() {

        ifÂ  (typeofÂ this.workItem$Â ===Â 'undefined') {
            console.error('e5core-ui-work-diarise [workItem$] must have a BehaviorSubject<WorkItemModel>');
            returnÂ ;
        }

        if (this.displayedTime == null) {
            const currentTime = this.formatAMPM(new Date());
            this.displayedTime = currentTime;
        }

        if (this.displayedDate == null) {
            this.displayedDate = new Date();
        }


        ifÂ  (typeofÂ this.workItem$Â !=Â null) {
            this.workItem$.subscribe(
                w => {
                    this.workId = w.workId;
                    if (this.showDiariseReasonDropdown) {
                        this.reasons = new Array<DiariseReasonModel>();
                        if (this.workId !== '00000000-0000-0000-0000-000000000000') {
                            this.GetDiariseReasons();
                        }
                    }
                }
            ) ;
        }

    }

    private calculateDiariseDate(clickedDiariseOption: DiariseOptionModel): void {

        const unit = parseInt(DiariseUnit[clickedDiariseOption.diariseUnit], 10);
        const increment = parseInt(clickedDiariseOption.value.toString(), 10);
        this.diariseDate = new Date();
        switch (unit) {
            case DiariseUnit.Tomorrow:
                {
                    this.diariseDate.setDate(this.diariseDate.getDate() + 1);
                    break;
                }
            case DiariseUnit.Days:
                {
                    this.diariseDate.setDate(this.diariseDate.getDate() + increment);
                    break;
                }
            case DiariseUnit.Months:
                {
                    this.diariseDate.setMonth(this.diariseDate.getMonth() + increment);
                    break;
                }
            case DiariseUnit.Weeks:
                {
                    this.diariseDate.setDate(this.diariseDate.getDate() + increment * 7);
                    break;
                }
            case DiariseUnit.Year:
                {
                    this.diariseDate.setFullYear(this.diariseDate.getFullYear() + increment);
                    break;
                }
        }

    }

    private setDatePickerDate() {
        // for(let datePicker of this.datePickerComponents.toArray()){
        //   datePicker.displayedDate = this.diariseDate;
        this.displayedDate = this.diariseDate;

    }

    private formatAMPM(tempDate: Date): string {
        let minuteString: string;
        let hours = tempDate.getHours();
        const minutes = tempDate.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minuteString = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
        const strTime = hours.toString() + ':' + minuteString + ' ' + ampm;
        return strTime;
    }

    onDiarisePeriodOptionClick($event: any) {
        this.calculateDiariseDate($event.diariseOption);
        this.setDatePickerDate();
        this.diarisePeriodOption = $event.diariseOption;
    }

    onDiariseButtonClick($event: DiariseWorkEvent) {

        //  ---Working Code------------------------------------------
        // 	let temp = {"AssessmentExplanationcode":"This is a test"};
        //   let menuData = {
        // 	"WorkItemChanges": WorkItemChanges,
        // 	"TaskChanges": null,
        // 	"AdditionalProperties": {
        // 		"result": "ok",
        // 		"DiariseReason": this.diariseReasonOption,
        // 		"DiariseUntilDate": formattedDiariseUntilDate,
        // 		"DiariseUntilHours": diariseHours,
        // 		"DiariseUntilMinutes": diariseMinutes
        // 	}
        // }
        //  _let diariseEvent : WorkDiariseEvent = {diariseOption:this.diarisePeriodOption,
        //  diariseUntilDate:diariseUntilDate, diariseUntilHours : diariseHours,
        //  diariseUntilMinutes : diariseMinutes, diariseTextReason : this.diariseReasonTextValue,
        //  diariseReasonOption : this.diariseReasonOption, menuData:menuData, source:"button"} ;
        //  ---Working Code------------------------------------------

        this.diariseWorkEvent =  this.ConstructWorkDiariseEvent('button');
        this.DiariseWorkItem();
    }

    onDiariseDateChange($event: any) {
        this.displayedDate = $event;
        this.diariseWorkEvent =  this.ConstructWorkDiariseEvent('date') ;
        this.dateChange.emit(this.diariseWorkEvent);
    }

    onDiariseReasonTextChange($event: any) {
        this.diariseReasonTextValue = $event;
        this.diariseReasonOption = $event;
        this.diariseWorkEvent =  this.ConstructWorkDiariseEvent('reasonText') ;
        this.reasonTextChange.emit(this.diariseWorkEvent);
    }

    onDiariseReasonChange($event: any) {
        this.diariseReasonOption = $event.value;
        this.diariseWorkEvent =  this.ConstructWorkDiariseEvent('reasonDropdown') ;
        this.reasonChange.emit(this.diariseWorkEvent);
    }

    onTimeChange(time: any) {
        this.displayedTime = time;
        const diariseWorkEvent: DiariseWorkEvent = this.ConstructWorkDiariseEvent('time') ;
        this.timeChange.emit(diariseWorkEvent);
    }

    GetDiariseReasons(): void {

        this.workItemFoundationService.getDiariseReasons(this.workId).subscribe(
            s => {
                const tempReasons: any = s.map(item => new DiariseReasonModel(item));
                this.reasons = tempReasons;
            },
            error => {
                console.error(error);
            }
        ) ;
    }

    public DiariseWorkItem(): void {
        this.diariseWorkEvent =  this.ConstructWorkDiariseEvent('diariseWorkItem');
        var options = {menuItemCode: "diarise"};
        this.workMenuItemService.invokeMenuItem(this.workId, -1, this.diariseWorkEvent.menuData, options).subscribe(
            s => {
                    this.diariseWork.emit(this.diariseWorkEvent);
            },
            error => {
                console.error(error);
            }
        ) ;
    }

    public ConstructWorkDiariseEvent(eventSource: any): DiariseWorkEvent {
        const WorkItemChanges = {};
        if (this.diariseReasonPropertyId != null && this.diariseReasonTextValue != null) {
            WorkItemChanges[this.diariseReasonPropertyId] = this.diariseReasonTextValue;
        }

        const diariseUntilTime = this.ConvertTime12to24(this.displayedTime).split(':');
        const diariseHours = parseInt(diariseUntilTime[0], 10);
        const diariseMinutes = parseInt(diariseUntilTime[1], 10);
        const diariseUntilDate = this.datePipe.transform(this.displayedDate, 'dd/MM/yyyy') ;

        const additionalProperties: AdditionalProperties = {
            result: 'ok',
            DiariseReason: this.diariseReasonOption,
            DiariseUntilDate: diariseUntilDate,
            DiaiseUntilHours: diariseHours,
            DiariseUntilMinutes: diariseMinutes
        };
        const menuData = {
            'WorkItemChanges': WorkItemChanges,
            'TaskChanges': null,
            'AdditionalProperties': {
                'result': 'ok',
                'DiariseReason': this.diariseReasonOption,
                'DiariseUntilDate': diariseUntilDate,
                'DiariseUntilHours': diariseHours,
                'DiariseUntilMinutes': diariseMinutes
            }
        } ;

        // let additionalProperties: AdditionalProperties = {result:"ok", DiariseReason:this.diariseReasonOption,
        //  DiariseUntilDate:formattedDiariseUntilDate,DiaiseUntilHours:diariseHours, DiariseUntilMinutes:diariseMinutes};
        // let menuData:DiariseMenuDataModel = {WorkItemChanges: WorkItemChanges, TaskChanges : null,
        //  AdditionalProperties:additionalProperties };

        const diariseEvent: DiariseWorkEvent = {
            diariseOption: this.diarisePeriodOption,
            diariseUntilDate: diariseUntilDate,
            diariseUntilHours : diariseHours,
            diariseUntilMinutes : diariseMinutes,
            diariseTextReason : this.diariseReasonTextValue,
            diariseReasonOption : this.diariseReasonOption,
            menuData: menuData,
            source: eventSource
        } ;
        return diariseEvent;
    }

    ConvertTime12to24(time12h): string {
        const [time, modifier] = time12h.split(' ');
        // tslint:disable-next-line:prefer-const
        let [hours, minutes] = time.split(':');
        if (hours === '12') {
            hours = '00';
        }
        if (modifier.toUpperCase() === 'PM') {
            hours = parseInt(hours, 10) + 12;
        }

        return hours + ':' + minutes;
    }
}
